// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-l_gM","advertDetailService__price":"c-l_gN"};